import { Box, Breadcrumbs, Grid, Typography } from "@material-ui/core";
import teamIMG from "../../../assets/team.png";

interface TmpSkeletonLeftPageCustomProps {
    title: any;
    subTitle: any;
    showImage?: boolean;
}


export default function TmpSkeletonLeftPageCustom(props: TmpSkeletonLeftPageCustomProps) {

    return (
        <Grid container>
            <Grid item xs={12}>
                <Box>
                    <Breadcrumbs aria-label="breadcrumb" separator=">">
                        <a style={{ color: "rgb(69, 167, 223)", textDecoration: "none", fontSize: "0.875rem" }} href="/"> Home </a>
                        <Typography style={{ fontSize: "0.875rem", fontFamily: "Inter,sans-serif", color: "rgb(143, 145, 148)" }}>SAM - Serviço de Apoio ao Médico</Typography>
                    </Breadcrumbs>
                </Box>
                <Box mt={3}>
                    <Typography style={{ margin: "0px 0px 1rem", fontSize: "3.375rem", marginTop: "3%", fontWeight: "700", fontFamily: "Inter,sans-serif", lineHeight: "1.1" }}>
                        <span dangerouslySetInnerHTML={{ __html: props.title }} />
                    </Typography>
                </Box>
                <Box mt={3}>
                    <Typography style={{ width: "100%", margin: "0px 0px 1rem", color: "#8F9194", fontSize: "16px", fontFamily: "Inter,sans-serif" }}>
                        {props.subTitle}
                    </Typography>
                </Box>
                {props.showImage ?
                    <img
                        src={teamIMG}
                        alt="imagem ilustrativa de uma equipe médica feliz"
                        style={{ width: "100%" }}
                    />
                    : null}
            </Grid>
            <Grid item>
            </Grid>
        </Grid>
    )
}